<template>
	<form method="post" :action="form.submit.url" class="wow fadeInUp">
		<div class="row">
			<!-- input -->
			<div class="col-xs-12 col-md-6">
				<div v-for="(field, key) in notTextArea" :key="key" :class="`field ${field.name}`">
					<label :for="field.name" :class="field.required ? 'required' : ''">{{field.label}}</label>
					<input :type="field.type" :id="field.name" :name="field.name" :required="field.required" />
				</div>
			</div>
			<!-- textarea -->
			<div class="col-xs-12 col-md-6">
				<div v-for="(field, key) in isTextArea" :key="key" :class="`field ${field.name}`">
					<label :for="field.name" :class="field.required ? 'required' : ''">{{field.label}}</label>
					<textarea :id="field.name" :name="field.name" :required="field.required" />
				</div>
			</div>
		</div>
		<!-- submit -->
		<div :class="`btn-wrapper ${form.submit.direction}`">
			<button :class="`btn ${form.submit.color}`" type="submit">{{form.submit.label}}</button>
		</div>
	</form>
</template>

<script>
//data
import Form from "../data-schema/Form.js";

export default {
	name: "Formulaire",
	props: {
		form: {
			type: Form,
			required: true
		}
	},
	computed: {
		isTextArea() {
			return this.form.fields.filter(field => field.type === "textarea");
		},
		notTextArea() {
			return this.form.fields.filter(field => field.type !== "textarea");
		}
	}
};
</script>